import { render, staticRenderFns } from "./BuyForm.vue?vue&type=template&id=1faf061d&scoped=true"
import script from "./BuyForm.vue?vue&type=script&lang=js"
export * from "./BuyForm.vue?vue&type=script&lang=js"
import style0 from "./BuyForm.vue?vue&type=style&index=0&id=1faf061d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf061d",
  null
  
)

export default component.exports